import { render } from "./ForgotPwForm.vue?vue&type=template&id=9e627310&scoped=true&ts=true"
import script from "./ForgotPwForm.vue?vue&type=script&lang=ts"
export * from "./ForgotPwForm.vue?vue&type=script&lang=ts"

import "./ForgotPwForm.vue?vue&type=style&index=0&id=9e627310&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e627310"]])

export default __exports__